import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {UntypedFormControl} from '@angular/forms';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {City} from '@models/city';

@Component({
    selector: 'app-change-city',
    templateUrl: './change-city.component.html',
    styleUrls: ['./change-city.component.scss']
})
export class ChangeCityComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    cityControl = new UntypedFormControl();
    cities: City[] = [];
    // Dernier nom valide : choisir une option écrit l'objet ville dans ad_city.name (ngModel)
    private cityName = '';

    constructor(
        public authService: AuthenticationService,
        public cityService: CityService,
        public adService: AdService,
        public commonService: CommonService) {
    }

    ngOnInit(): void {
        this.cityName = this.favorite.ad_city.name;
        this.cityControl.valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                // tap(() => this.isLoading = true),
                switchMap(value => this.cityService.searchCommune(this.favorite.ad_city.name))
                // .pipe(finalize(() => this.isLoading = false))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.cities = d;
            });
    }

    changeCity(value) {
        this.cityService.getCity(value.city_code).subscribe(c => {
            if (!c) {
                this.favorite.ad_city.name = this.cityName;
                return;
            }
            this.favorite.ad_city = c;
            this.cityName = c.name;
            if (this.favorite.ad_city.carac_commune) {
                this.favorite = this.adService.cleanInput(this.favorite);
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        });
    }
}
